module.exports = __webpack_public_path__ + "static/Logo-2667b059fd4d07c3235cd1504c93ae1a.svg";